export interface TslintProject {
    readonly preset: "softwareventures" | "other";
}
